if (!N3N) var N3N = {};
N3N.WizeyeVideoPlayer = function() {
  this.init.apply(this);
};

var L;
if ( L ) {
	var n3nL = {
		DivOverlay: {
			extend: function ( o ) {
				return o;
			}
		}
	};
	var L = Object.assign( L, n3nL );
} else {
	var L = {
		DivOverlay: {
			extend: function ( o ) {
				return o;
			}
		}
	};
}

var P = {
  MapPlayer: {
    Render: {
      extend: function(o) {
        return o;
      },

      include: function(o) {
        return o;
      }
    }
  }
};

N3N.WizeyeVideoPlayer.prototype = {
  init: function() {
    this._player_id = (Date.now() + Math.floor(Math.random() * 100000000)).toString();
  },

  httpQuery: function(url, type, data, callback) {
    // compatible with IE7+, Firefox, Chrome, Opera, Safari
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function() {
      if (xmlhttp.readyState === 4) {
        if (xmlhttp.status !== 200) {
          console.log('xmlhttp.status: ', xmlhttp.status);
        }

        callback(xmlhttp.responseText, xmlhttp.status);
      }
    };

    xmlhttp.open((data) ? 'POST' : 'GET', url, true);
    xmlhttp.setRequestHeader('Content-type', type);
    if (data && type === 'application/json') {
      xmlhttp.send((data) ? JSON.stringify(data) : null);
    } else {
      xmlhttp.send(data);
    }
  },

  stretch: function(enable) {
    console.log('stretch');
  },

  loadScript: function(src, callback) {
    var scripts = document.getElementsByTagName('script');
    var i = 0;
    for (i = 0; i < scripts.length; i++) {
      if (scripts[i].src.indexOf(src) !== -1) break;
    }

    if (scripts.length === 0 || i === scripts.length) {
      var script = document.createElement('script');
      script.src = src;
      script.onload = callback;
      document.head.appendChild(script);
      console.log(src + ' is loaded now.');
    } else {
      console.log(src + ' has been loaded already.');
      setTimeout(callback, 1000);
    }
  },

  // open: function(divName, wizeyeUrl, objectName, accessToken, bPlayback) {
  //   var me = this;
  //
  //   this.divName = divName;
  //   this.objectName = objectName;
  //   this.wizeyeUrl = wizeyeUrl;
  //   this.bPlayback = bPlayback;
  //
  //   if (!window.n) {
  //     this.loadScript(wizeyeUrl + '/public/mediaplayer/ddp.js', function() {
  //       console.log('ddp loaded');
  //       if (!window.n) //double check
  //       {
  //         window.n = new N3N.DDP();
  //         n.onopen = me.ddp_ready.bind(me);
  //         n.openWithToken(wizeyeUrl, accessToken);
  //
  //         // me.httpQuery(wizeyeUrl + "/publicAccess?token=" + accessToken, null, null, function(token, status) {
  //         // 	if (status == 200)
  //         // 	{
  //         // 		console.log("token: ", token);
  //         // 		var ddpUrl = wizeyeUrl.trim();
  //         // 		window.n = new N3N.DDP();
  //         // 		if (ddpUrl.startsWith("https://")) ddpUrl = "wss://" + ddpUrl.substr(8) + "/echo?token=" + token;
  //         // 		else if (ddpUrl.startsWith("http://")) ddpUrl = "ws://" + ddpUrl.substr(7) + "/echo?token=" + token;
  //         // 		else ddpUrl = "ws://" + ddpUrl + "/echo?token=" + token;
  //         // 		console.log("ddpUrl: " + ddpUrl);
  //         // 		n.onopen = me.ddp_ready.bind(me);
  //         // 		n.open(ddpUrl);
  //         // 	}
  //         // });
  //
  //       } else {
  //         this.ddp_ready();
  //       }
  //     }.bind(this));
  //   } else {
  //     this.ddp_ready();
  //   }
  //
  //   console.log('open');
  // },

  open: function(divName, wizeyeUrl, objectName, accessToken, bPlayback, zIndex, uiLeft, uiTop, uiWidth, uiHeight, mediaLeft, mediaTop, mediaWidth, mediaHeight) {
    var me = this;

    this.divName = divName;
    this.objectName = objectName;
    this.wizeyeUrl = wizeyeUrl;
    this.bPlayback = bPlayback;
    this.inputArea = {
      z_index: zIndex,
      left: uiLeft,
      top: uiTop,
      width: uiWidth,
      height: uiHeight,
      clip_left: mediaLeft,
      clip_top: mediaTop,
      clip_width: mediaWidth,
      clip_height: mediaHeight
    };

    if (!window.n) {
      this.loadScript(wizeyeUrl + '/public/mediaplayer/ddp.js', function() {
        console.log('ddp loaded');
        if (!window.n) //double check
        {
          window.n = new N3N.DDP();
          n.onopen = me.ddp_ready.bind(me);
          n.openWithToken(wizeyeUrl, accessToken);
        } else {
          this.ddp_ready();
        }
      }.bind(this));
    } else {
      this.ddp_ready();
    }

    console.log('open');
  },

  ddp_ready: function() {
    this.loadScript(this.wizeyeUrl + '/modules/@uielement/videowin/lib/P.MapPlayer.Render.Video.js?token=' + n.token(), function() {
      var me = this;
      console.log('loaded : ', this.objectName);
      this.lib = new L.VideoWin.Lib();
      console.log('lib: ', this.lib);
      this.contentNode = document.getElementById(this.divName);
      this.lib.initialize(this.contentNode);
      this.lib._player_id = me._player_id;
      this.lib.inputArea = me.inputArea;
      this.lib.setWizeyeUrl(this.wizeyeUrl);
      this.lib.updateVideo(this.objectName, (this.bPlayback === true) ? true : false);
      this.lib.onEvent = function(msg) {
        if (me.onEvent) me.onEvent(msg);
      };
    }.bind(this));
  },

  close: function() {
    console.log('close');
    this.lib.destroy();
  },

  controlPanTilt: function(pan, tilt) {
    this.lib.controlPanTilt(pan, tilt);
  },

  controlZoom: function(zoom) {
    this.lib.controlZoom(zoom);
  },

  gotoPreset: function(presetName) {
    this.lib.gotoPreset(presetName);
  },

  setPreset: function(presetName) {
    this.lib.setPreset(presetName);
  },

  removePreset: function(presetName) {
    this.lib.removePreset(presetName);
  },

  gotoHome: function() {
    this.lib.gotoHome();
  },

  saveAsImage: function(filePath) {
    this.lib.saveAsImage(filePath);
  },

  startSaveAsVideo: function(filePath) {
    this.lib.startSaveAsVideo(filePath);
  },

  exportVideo: function(filePath, start, end) {
    this.lib.exportVideo(filePath, start, end);
  },

  endSaveAsVideo: function() {
    this.lib.endSaveAsVideo();
  },

  addPopupArea: function(id, zIndex, left, top, width, height) {
    document.dispatchEvent(new CustomEvent('n3n_video_player', { detail: { command: 'popup_show', id: id, zIndex: parseInt(zIndex), left: parseInt(left), top: parseInt(top), width: parseInt(width), height: parseInt(height) } }));
  },

  removePopupArea: function(id) {
    document.dispatchEvent(new CustomEvent('n3n_video_player', { detail: { command: 'popup_hide', id: id } }));
  },

  move: function(zIndex, uiLeft, uiTop, uiWidth, uiHeight, mediaLeft, mediaTop, mediaWidth, mediaHeight) {
    document.dispatchEvent(new CustomEvent('n3n_video_player', { detail: { command: 'wvp_move_element', element_id: this._player_id, area: { z_index: parseInt(zIndex), left: parseInt(uiLeft), top: parseInt(uiTop), width: parseInt(uiWidth), height: parseInt(uiHeight), clip_left: parseInt(mediaLeft), clip_top: parseInt(mediaTop), clip_width: parseInt(mediaWidth), clip_height: parseInt(mediaHeight) } } }));
  },

  setZIndex: function(zindex) {
    this.lib.setZIndex(zindex);
  },

  play: function() {
    this.lib.play();
  },

  pause: function() {
    this.lib.pause();
  },

  stop: function() {
    this.lib.stop();
  },

  seek: function(from, to) {
    this.lib.seek(from, to);
  },

  show: function() {
    this.lib.show();
  },

  hide: function() {
    this.lib.hide();
  },

  setPlaybackSpeed: function(speed) {
    this.lib.setPlaybackSpeed(speed);
  },

  setPlaybackDirection: function(direction) {
    this.lib.setPlaybackDirection(direction);
  }
};
